<template>
  <van-swipe
    :autoplay="3000"
    :show-indicators="false"
    :stop-propagation="false"
    :class="$style.box"
    :style="{ width: '100%', height: heightAuto ? 'auto' : '70px' }"
  >
    <van-swipe-item v-for="item of topBannerList" :key="item.id" @click="handleLink(item)">
      <img :src="item.banner" alt="顶部轮播图" width="100%" />
    </van-swipe-item>
  </van-swipe>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';
import { reportData } from '@/api/report';
export default {
  props: {
    topBannerList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    heightAuto: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem
  },
  methods: {
    async handleLink(item) {
      try {
        const r = await reportData({
          type: 7,
          data_type: 4,
          recommend_id: item.id
        })
      } catch (error) {
        console.log(error);
      }
      setTimeout(() => {
        window.open(item.url, "_self");
      }, 200);
    }
  },
};
</script>

<style lang="scss" module>
.box {
  position: relative;
  z-index: 199;
}
</style>
